import React, { PureComponent } from 'react'
import styled, { keyframes } from 'styled-components'
import Logomark from '../layout/logomark.component'

import { content } from '../../../config'

const { LOGO_LOADING, BRAND_NAME } = content

const logoLoading = require(`../../../assets/images/${LOGO_LOADING}`)

const animateColor = keyframes`
    from { background-color: white; }
    to { background-color: ; }
`

const StyledBackdrop = styled.div`
	position: fixed;
	left: 0;
	top: 0;
	height: 100vh;
	width: 100vw;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: ${(props) =>
		props.transparent ? 'rgba(255, 255, 255, 0.5)' : '#FFF'};
	z-index: 9;

	.logo-container {
		display: flex;
		align-items: center;

		.orange,
		.blue,
		.yellow {
			animation: ${animateColor} 0.6s infinite;
			animation-direction: alternate;
		}
	}
`

class Loader extends PureComponent {
	constructor(props) {
		super(props)
		this.props = props
		this.state = {
			fade: false,
			showLoader: props.showLoader,
		}
	}

	removeLoader = () => {
		this.setState({ fade: true }, () => {
			this.setState({
				showLoader: this.props.showLoader,
				fade: false,
			})
		})
	}

	componentWillReceiveProps(nextProps) {
		this.props.showLoader !== nextProps.showLoader && this.removeLoader()
	}

	getClassName = () => `animated ${this.state.fade ? 'fadeOut' : 'fadeIn'}`

	render() {
		return (
			this.state.showLoader && (
				<StyledBackdrop
					transparent={this.props.transparent}
					className={this.getClassName()}>
					<div className="logo-container">
						<Logomark animate />
						<img src={logoLoading} alt={`Logomarca ${BRAND_NAME}`} />
					</div>
				</StyledBackdrop>
			)
		)
	}
}

export default Loader
